export class PartnersInsuranceRelationDto {
    constructor(initializer) {
        this.vehicleModelId = initializer.vehicleModelId;
        this.vehicleModelName = initializer.vehicleModelName;
        this.insuranceId = initializer.insuranceId;
        this.insuranceName = initializer.insuranceName;
        this.partnersInsuranceId = initializer.partnersInsuranceId;
    }
}
